import { BaseQueryFn, EndpointBuilder } from '@reduxjs/toolkit/query';
import { ProductDto } from '../types/dtos';
import { APP_ENDPOINTS } from 'app/endpoints';

export default (builder: EndpointBuilder<BaseQueryFn, string, string>) =>
    builder.mutation<void, { id: string; payload: Partial<ProductDto> }>({
        query: ({ id, payload }) => ({
            url: `${APP_ENDPOINTS.PRODUCT}/${id}`,
            method: 'PATCH',
            body: payload,
        }),
        invalidatesTags: [
            { type: 'product', id: 'GET-ID' },
            { type: 'products', id: 'GET' },
            { type: 'products-with-join', id: 'GET-JOIN' },
            { type: 'product-nested-products', id: 'GET' },
        ],
    });
